var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM7 12.6875C3.86367 12.6875 1.3125 10.1361 1.3125 7C1.3125 3.86395 3.86367 1.3125 7 1.3125C10.1363 1.3125 12.6875 3.86395 12.6875 7C12.6875 10.1361 10.1363 12.6875 7 12.6875ZM7 9.1875C6.50781 9.1875 6.125 9.57031 6.125 10.0625C6.125 10.5547 6.4832 10.9375 7 10.9375C7.46758 10.9375 7.875 10.5547 7.875 10.0625C7.875 9.57031 7.46758 9.1875 7 9.1875ZM7.90508 3.5H6.50781C5.44141 3.5 4.59375 4.34766 4.59375 5.41406C4.59375 5.76953 4.89453 6.07031 5.25 6.07031C5.60547 6.07031 5.90625 5.76953 5.90625 5.41406C5.90625 5.08594 6.15508 4.8125 6.4832 4.8125H7.88047C8.2332 4.8125 8.53125 5.08594 8.53125 5.41406C8.53125 5.63281 8.42188 5.79961 8.23047 5.90898L6.67188 6.86328C6.45312 7 6.34375 7.21875 6.34375 7.4375V7.875C6.34375 8.23047 6.64453 8.53125 7 8.53125C7.35547 8.53125 7.65625 8.23047 7.65625 7.875V7.82031L8.88945 7.05469C9.46367 6.69922 9.81914 6.07031 9.81914 5.41406C9.84375 4.34766 8.99609 3.5 7.90508 3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b9f9b4ed65a1344a87181c635c19aa99.svg";
export { ForwardRef as ReactComponent };